import { AnalysisCategory } from '../../services/subscriptionService';

export interface AnalysisCategoryMeta {
  id: AnalysisCategory;
  path: string;
  label: string;
  icon: string;
  description: string;
  /** Shipped views; the rest render a "coming soon" tile. */
  available: boolean;
}

// Fixed order — drives both the hub tiles and the tab strip.
export const ANALYSIS_CATEGORIES: AnalysisCategoryMeta[] = [
  {
    id: 'sales',
    path: 'sales',
    label: 'Sales',
    icon: '💰',
    description: 'Revenue trends, ADR, RevPAS, and booking lead time.',
    available: true,
  },
  {
    id: 'occupancy',
    path: 'occupancy',
    label: 'Occupancy',
    icon: '🏕️',
    description: 'Occupancy rates, weekend patterns, gap nights, and blackout impact.',
    available: true,
  },
  {
    id: 'payments',
    path: 'payments',
    label: 'Payments',
    icon: '💳',
    description: 'Failed payments, refunds, balances due, and payment mix.',
    available: true,
  },
  {
    id: 'anomalies',
    path: 'anomalies',
    label: 'Anomalies',
    icon: '🚨',
    description: 'Bookings and payments that need a second look.',
    available: true,
  },
  {
    id: 'product',
    path: 'product',
    label: 'Product',
    icon: '📦',
    description: 'Site popularity, length of stay, and fee trends.',
    available: true,
  },
  {
    id: 'cancellations',
    path: 'cancellations',
    label: 'Cancellations',
    icon: '↩️',
    description: 'Cancellation rates, reasons, and recovered nights.',
    available: true,
  },
  {
    id: 'members',
    path: 'members',
    label: 'Members',
    icon: '👥',
    description: 'Guest loyalty, RFM segments, and churn risk.',
    available: true,
  },
  {
    id: 'pacing',
    path: 'pacing',
    label: 'Pacing',
    icon: '📈',
    description: 'Booking pace and projected occupancy.',
    available: true,
  },
];
